<template>
	<div class="app-main">
        <el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="14">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="10" class="app-main-header-btns">
				<el-button size="small" type="primary" v-show="checkRole('cgy_role') && orderInfo.state == 0" @click="handerOrder(1)">发布订单</el-button>
				<el-button size="small" type="primary" v-show="checkRole('gys_role') && orderInfo.state == 1" @click="handerOrder(2)">订单确认</el-button>
				<el-button size="small" type="primary" v-show="showBtnJDWH" @click="handerOrder(3)">订单交付进度维护</el-button>
				<el-button size="small" type="primary" @click="$router.back(-1)">返回 </el-button>
			</el-col>
		</el-row>
        <div class="order-info-main">
            <div class="info-wrap">
                <el-row class="mg-b5">
                    <el-col :span="24">
						<el-card class="box-card mg-b5" v-if="orderInfo">
							<el-descriptions :column="4" :border="true" :colon="false" size="mini">
								<el-descriptions-item labelClassName="my-descriptions-label" label="订单号"> {{orderInfo.orderCode}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="询价单号"> {{orderInfo.xjOrderCode}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="订单日期"> {{orderInfo.orderTime}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="客户"> {{orderInfo.customName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="供应商"> {{orderInfo.gysName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="采购员"> {{orderInfo.cgyName}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="订单状态"> {{getStateText(orderInfo.state)}} </el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="订单确认日期"> {{orderInfo.orderConfirmTime}} </el-descriptions-item>
								<!-- <el-descriptions-item labelClassName="my-descriptions-label" label="NC订单主表主键"> {{orderInfo.no}} </el-descriptions-item> -->
							</el-descriptions>
						</el-card>
					</el-col>
					<el-col :span="24">
						<el-card class="box-card" style="min-height:calc(100vh - 200px);position: relative;">
							<el-tabs v-model="activeName">
								<el-tab-pane label="物料列表" name="first">
									<MateriaTable v-if="hId && orderInfo" :showBtnJDWH="showBtnJDWH" ref="MateriaTableRef" @callback="MateriaTableCallback"  :hId="hId" :orderInfo="orderInfo" :editOrderFlag="editOrderFlag" pageFlag="OmgOrderDetail"/>
								</el-tab-pane>
							</el-tabs>
							<div class="tab-pane-btns">
								<el-button v-if="activeName == 'first' && orderInfo && orderInfo.state == 1 && checkRole('gys_role') && !editOrderFlag" size="small" type="primary" @click="updateOrder">订单编辑</el-button>
								<el-button v-if="activeName == 'first' && orderInfo && orderInfo.state == 1 && checkRole('gys_role') && editOrderFlag" size="small" type="primary" @click="saveUpdateOrder">保存</el-button>
							</div>
						</el-card>
					</el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import MateriaTable from './MateriaTable.vue'
import { orderById , publishFinalOrder,gysUpdateList,confirmFinalOrder} from '@/api/omg/index.js';
export default {
    name: "OmgOrderDetail",
	components:{
		MateriaTable
	},
    data() {
        return {
			hId:'',
			orderInfo:{},
			activeName:'',
			editOrderFlag:false,
        }
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
		showBtnJDWH: function(){
			return this.checkRole('gys_role') && this.orderInfo.state == 2;
		},
    },
    created() {
		let route = this.$route;
        this.hId = route.params.id;  // 详情id
        this.getInquiryById();
		this.activeName = 'first'
    },
    methods:{
        getInquiryById(){
			orderById({id:this.hId}).then(({data:res})=>{
				console.log(res)
				if(res.code == 0){
					this.orderInfo = res.data;
				}
			})
        },
		handerOrder(type){
			let _this = this;
			if(type == 1){	// 采购员发布订单
				publishFinalOrder({id:this.hId}).then(({data:res})=>{
					console.log(res)
					if(res.code == 0){
						_this.$success('操作成功');
						_this.getInquiryById()
					}
				})
			}
			if(type == 2){	// 供应商 确认订单
				confirmFinalOrder({id:this.hId}).then(({data:res})=>{
					if(res.code == 0){
						_this.$success('操作成功');
						_this.getInquiryById()
					}
				})
			}
			if(type == 3){
				this.$refs.MateriaTableRef.openProgressDialog();
			}
		},
		MateriaTableCallback(obj){

		},
		getStateText(state){
			let stateObj = {};
			if(this.checkRole('cgy_role')){	// 采购员
				stateObj = {
					's_0':'待发布',
					's_1':'确认中',
					's_2':'已确认',
					's_3':'送货计划',
					's_4':'已签收',
					's_5':'已入库',
					's_6':'已开票',
				}
			}else{	// 供应商
				stateObj = {
					's_1':'待确认',
					's_2':'已确认',
					's_3':'送货计划',
					's_4':'已签收',
					's_5':'已入库',
					's_6':'已开票',
				}

			}
			return stateObj[`s_${state}`];
		},
		// 订单编辑
		updateOrder(){
			this.editOrderFlag = true;
		},
		// 订单编辑保存
		async saveUpdateOrder(){
			let tableList = [...this.$refs.MateriaTableRef.showTableData];
			let prama = [];
			tableList.forEach((item)=>{
				prama.push({
					id:item.id,
					canProvide:item.colCanProvide?'是':'否',
					provideDate:item.provideDate,
					// remark:item.remark,
				})
			})
			const { data: res } = await gysUpdateList(prama)
			if(res.code == 0){
				this.editOrderFlag = false;
				this.$refs.MateriaTableRef.getList();
			}
		},
    },
	watch:{
		'activeName':function(nVal){
			console.log(nVal)
		},
	}
}
</script>
<style scoped="scoped" lang="scss">
	.order-info-main{
		width: 100%;
		display: flex;
		.info-wrap{
			width: 100%;
			&.has-audit-list{
				width: calc(100% - 310px);
			}
		}
		.audit-wrap{
			width: 300px;
			height: calc(100vh - 200px);
			/* background: #fff; */
			margin-left: 10px;
			margin-top: 0px;
			.audit-list-box{
                width: 100%;
				height: calc(100vh - 170px);
				overflow-y: auto;
                .audit-item{
                    margin-bottom: 30px;
					/* background: #eee; */
					border-bottom: 1px solid #e8e8e8;
                    .bar{
                        display: flex;
                        height: 40px;
                        justify-content: space-between;
						.name-box{
							.name{
								font-size: 14px;
								font-weight: 700;
								color: #333;
								line-height: 20px;
							}
							.time{
								font-size: 12px;
								color: #999;
								line-height: 20px;
							}
						}
                    }
                    .bh-reson{
                        width: calc(100% - 20px);
                        background: #eee;
                        text-align: justify;
                        padding: 10px;
                        margin: 10px 0;
						border-radius: 5px;
						font-size: 12px;
                    }
                }
            }
		}
	}
	.app-main-time {
		display: flex;
		flex-direction: row;
		text-align: center;
		justify-content: space-between;

	}
	.tab-pane-btns{
		height: 32px;
		position: absolute;
		right: 10px;
    	top: 5px;
		text-align: right;
		.show-tender-row-switch{
			height: 32px;
			line-height: 32px;
			font-size: 14px;
			display: flex;
			.el-switch{
				margin-top: 6px;
			}
			span{
				line-height: 32px;
				margin-right: 10px;
			}
		}
	}
</style>
